import {
  UploadsMediaSubTab,
  UploadsMediaType,
  USER_AI_GENERATED_AUDIO_GRID_ID,
  USER_AI_GENERATED_IMAGE_GRID_ID,
  USER_AUDIO_UPLOADS_GRID_ID,
  USER_BG_IMAGE_UPLOADS_GRID_ID,
  USER_IMAGE_UPLOADS_GRID_ID,
  USER_VIDEO_UPLOADS_GRID_ID,
  UserMediaPanelAiOption,
} from '@Panels/user-media-panel/user-media-panel.types';
import {StockPanelTabs} from '@Panels/stock-panel/stock-panel.types';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE, ControlledListItemSize} from '@Components/controlled-list/controlled-list.types';

export const getStockTabForUploadsTab = (tab: UploadsMediaType): StockPanelTabs => {
  switch (tab) {
    case UploadsMediaType.VIDEO:
      return StockPanelTabs.VIDEOS;
    case UploadsMediaType.AUDIO:
      return StockPanelTabs.AUDIOS;
    case UploadsMediaType.IMAGE:
    case UploadsMediaType.IMAGE_BACKGROUND:
    default:
      return StockPanelTabs.PHOTOS;
  }
};

export const getAllStockPanelTabs = (): Array<StockPanelTabs> => {
  return [
    StockPanelTabs.ALL,
    StockPanelTabs.PHOTOS,
    StockPanelTabs.VIDEOS,
    StockPanelTabs.AUDIOS,
    StockPanelTabs.TEXT_TO_IMAGE,
    StockPanelTabs.ICONS,
    StockPanelTabs.SHAPES,
    StockPanelTabs.STICKERS,
  ];
};

export const getGridIdForTabStates = (tab: UploadsMediaType, subTab: UploadsMediaSubTab): string => {
  switch (tab) {
    case UploadsMediaType.IMAGE:
      return subTab === UploadsMediaSubTab.AI_IMAGE ? USER_AI_GENERATED_IMAGE_GRID_ID : USER_IMAGE_UPLOADS_GRID_ID;
    case UploadsMediaType.AUDIO:
      return subTab === UploadsMediaSubTab.AI_VOICE ? USER_AI_GENERATED_AUDIO_GRID_ID : USER_AUDIO_UPLOADS_GRID_ID;
    case UploadsMediaType.IMAGE_BACKGROUND:
      return USER_BG_IMAGE_UPLOADS_GRID_ID;
    case UploadsMediaType.VIDEO:
      return USER_VIDEO_UPLOADS_GRID_ID;
    default:
      throw new Error(`Unhandled tab: ${tab} with subtab: ${subTab}`);
  }
};

export const getItemsforAiOptionsDropdown = (mediaTypesToShow: UploadsMediaType[]): ControlledListItemType[] => {
  const items: ControlledListItemType[] = [];

  if (mediaTypesToShow.includes(UploadsMediaType.IMAGE) || mediaTypesToShow.includes(UploadsMediaType.IMAGE)) {
    items.push({
      id: UserMediaPanelAiOption.AI_IMAGE,
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
      text: window.i18next.t('pmwjs_ai_image'),
      icon: 'icon-ai-image',
      listSize: ControlledListItemSize.MEDIUM,
    });
  }
  if (mediaTypesToShow.includes(UploadsMediaType.AUDIO)) {
    items.push({
      id: UserMediaPanelAiOption.AI_VOICE,
      type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
      text: window.i18next.t('pmwjs_ai_voice'),
      icon: 'icon-ai-voice',
      listSize: ControlledListItemSize.MEDIUM,
    });
  }

  return items;
};

export const getAiVoicePanelId = (parentPanelId: string): string => {
  return `${parentPanelId}-ai-voice-via-user-media-panel`;
};
